const Hero = () =>{
    return (
        <>
        <div className="hero">
        <div className="about">
        <h1 className="hero-h3">CLOUDSPORT JUJUY - Tienda Virtual</h1>
        <h3 className="hero-h3">About Us</h3>
        <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."</p>
        </div>
        </div>
        </>
    )
}
export default Hero;